import { gate } from 'hub-http/gates';
export const MULTI_CURRENCY_MIGRATION_GATE = gate('CRM:MultiCurrency:MigrateV1ToV2Frontend');
export const MULTI_CURRENCY_V1_ENDPOINT = 'multi-currency/v1/currencies/information';
export const MULTI_CURRENCY_V2_ENDPOINT = 'multi-currency/v2/currencies/information';